/* @flow */
import styled from "styled-components";

const StyledVideo = styled.video`
  box-sizing: border-box;
  width: 100%;
`;

export default StyledVideo;
